// extracted by mini-css-extract-plugin
module.exports = {"dialog-wrap":"style_dialog-wrap___DIa7","dialog-box":"style_dialog-box__1x4mH","content":"style_content__1QMDh","btn":"style_btn__1UHNs"};